import React from 'react';
import { PieChart as Chart, Pie, Cell, ResponsiveContainer } from 'recharts';

import './PieChart.scss';

const COLORS = ['#323232', '#d52b1e'];
const RADIAN = Math.PI / 180;

export const PieChart = function({ data }) {

	const renderCustomizedLabel = (props) => {
		const {
			cx, cy, midAngle,
			innerRadius,
			percent, index
		} = props;

		const radius = innerRadius * 0.5;
		const x = cx + radius * Math.cos(-midAngle * RADIAN);
		const y = cy + radius * Math.sin(-midAngle * RADIAN);

		return <svg x={x - 40} y={y - 20}>
			<text
				x={0}
				y={15}
				fill={COLORS[index % COLORS.length]}
				textAnchor='start'
				dominantBaseline='central'
				className='value'
				style={{opacity: 0}}
			>
				<animate attributeType="CSS" attributeName="opacity" from="0" to="1" dur="1s" fill="freeze"/>
				{`${(percent * 100).toFixed(1)}%`}
			</text>
			<text
				x={2}
				y={40}
				fill='black'
				textAnchor='start'
				dominantBaseline='central'
				className='label'
				style={{opacity: 0}}
			>
				<animate attributeType="CSS" attributeName="opacity" from="0" to="1" dur="1s" fill="freeze"/>
				{data[index].Label}
			</text>
		</svg>;
	};

	return (
		<ResponsiveContainer width='100%' height='100%'>
			<Chart className='pie-chart'>
				<Pie
					data={data}
					labelLine={false}
					label={renderCustomizedLabel}
					innerRadius="73%"
					outerRadius="85%"
					paddingAngle={1}
					fill='#000'
					dataKey='Value'
					stroke='transparent'
					strokeWidth="2%"
					animationBegin={2000}
					animationDuration={2000}
					startAngle={90}
					endAngle={-270}
				>
					{data.map((entry, index) => (
						<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
					))}
				</Pie>
			</Chart>
		</ResponsiveContainer>
	);
};